import { Component, computed, effect, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { UserStore } from '../../../store/user.store';
import { PNS_LIST_ROUTE } from '../../../../app.routes';

@Component({
  selector: 'dnv-side-menu',
  imports: [
    MatIconModule
  ],
  templateUrl: './side-menu.html',
})
export class SideMenu {

  private readonly router = inject(Router);
  private readonly userStore = inject(UserStore);
  public readonly isUserAdmin = computed(
    () => this.userStore.currentUser()?.administrator ?? false
  );

  readonly PNS_LIST_ROUTE = PNS_LIST_ROUTE;

  constructor() {
    effect(() => {
      this.userStore.currentUser();
    });
  }

  onNavigate(link: string): void {
     this.router.navigate([link]);
  }

}
